// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Conditionally includes items in an array spread.
 * Useful for building arrays with optional elements based on conditions.
 *
 * @example
 * const actions = [
 *   ...when(isAdmin, [{ name: 'Delete', action: deleteItem }]),
 *   ...when(canEdit, [{ name: 'Edit', action: editItem }]),
 * ];
 *
 * @param condition - The condition to evaluate
 * @param items - The items to include if condition is true
 * @returns The items array if condition is truthy, otherwise an empty array
 */
export const when = <T>(condition: unknown, items: T[]): T[] => (condition ? items : []);
